module.exports = __webpack_public_path__ + "img/cara-triste.95cfc74e.svg";